export function Icon({ src, alt } = {}) {
    return { src, alt };
}
